import { render } from 'preact';
import { App } from './App.js';
import { startPresence } from './presence.js';

declare global {
  interface Window {
    bokameChatCtx?: {
      backendUrl: string;
      brandColor?: string;
      identityToken?: string;
      privacyUrl?: string;
    };
  }
}

// RGPD — deux contrats bien distincts cohabitent dans ce fichier :
//
// 1) Le chat (App.tsx) : « rien ne charge avant le premier clic » — pas de
//    fetch, pas de WebSocket, pas de lecture localStorage tant que le
//    visiteur n'a pas cliqué sur le bouton flottant (cf. contrat détaillé
//    dans App.tsx).
//
// 2) La présence « en direct » (presence.ts), démarrée ici immédiatement,
//    AVANT tout clic — c'est son but : permettre à un agent de voir qui
//    navigue sur bokame.com en ce moment, même sans avoir ouvert le chat
//    (façon Crisp MagicMap). Fondement : intérêt légitime (assistance
//    proactive), pas de profilage. Le canal reste minimal par construction :
//      - aucun cookie, aucun localStorage — un UUID en sessionStorage
//        (meurt avec l'onglet, ne relie jamais deux visites) ;
//      - aucune donnée envoyée à un tiers ;
//      - rien n'est écrit en base côté serveur : stockage en mémoire avec
//        expiration automatique (~90s sans nouveau signal) — voir
//        backend/src/presence/store.ts et
//        docs/superpowers/specs/2026-09-29-live-visitors.md.
//    Détail des données et de la justification : voir presence.ts.
(function bootstrap(): void {
  if (typeof window === 'undefined') return;
  const ctx = window.bokameChatCtx;
  if (!ctx || !ctx.backendUrl) {
    console.warn('[bokame-chat] window.bokameChatCtx.backendUrl missing — widget not mounted');
    return;
  }

  startPresence({ backendUrl: ctx.backendUrl, identityToken: ctx.identityToken });

  if (document.getElementById('bokame-chat-root')) return; // already mounted

  const root = document.createElement('div');
  root.id = 'bokame-chat-root';
  document.body.appendChild(root);

  render(<App ctx={ctx} />, root);
})();
